





















// vendor
import { defineComponent, PropType, computed } from "@vue/composition-api";
// local
import { Information, FormItem } from "../../ts/types";

export default defineComponent({
	props:{
		config:{
			type:Object as PropType<FormItem<Information>>,
			required:true
		}
	},
	setup(props){
		const title = computed(() => props.config.settings.title);
		const body = computed(() => props.config.settings.text.trim());
		return {
			title,
			body
		};
	}
});
